import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

// styles used by the others components.
import {
  QuestionLabel,
  TextError,
  Container,
  OptionContainer,
} from '../styles';

import {
  Checkbox,
} from './styles';
import InputOtherDescription, { ERROR_TEXT_INPUT_OTHER } from '../input-other-description';
import { OPTION_TYPE_VALUE } from '../constants';

const SingleQuestionType = (props) => {
  const {
    questionOptions,
    label,
    errorText,
    errorField,
    onChange,
    selectedValue,
    isScreener,
  } = props;
  const [showInputOther, setShowInputOther] = useState(false);

  const handleClickCheckbox = (idQuestion, optionType) => {
    onChange({ [idQuestion]: true });

    if (optionType === OPTION_TYPE_VALUE) {
      setShowInputOther(true);
    } else {
      setShowInputOther(false);
    }
  };

  const isInputOther = useMemo(() => questionOptions
    .some(({ id, optionType }) => optionType === OPTION_TYPE_VALUE
      && Object.prototype.hasOwnProperty.call(selectedValue, id)), [questionOptions, selectedValue]);

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
      {questionOptions.map(({ id, label: labelOption, optionType }) => (
        <OptionContainer key={id} optionType={optionType}>
          <Checkbox
            data-selection={labelOption}
            radio
            key={id}
            label={labelOption}
            onChange={() => handleClickCheckbox(id, optionType)}
            checked={!!selectedValue[id]}
          />
          {(optionType === OPTION_TYPE_VALUE && !isScreener) && (
            <InputOtherDescription
              showInputOther={showInputOther}
              onChange={onChange}
              selectedValue={selectedValue}
              errorField={errorField}
            />
          )}
        </OptionContainer>
      ))}

      {errorField && !isInputOther && (
        <TextError>
          {errorText}
        </TextError>
      )}

      {errorField && isInputOther && showInputOther && (
        <TextError>
          {ERROR_TEXT_INPUT_OTHER}
        </TextError>
      )}
    </Container>
  );
};

SingleQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
    optionType: PropTypes.string,
  })).isRequired,
  errorField: PropTypes.bool,
  onChange: PropTypes.func,
  selectedValue: PropTypes.shape({}),
  isScreener: PropTypes.bool.isRequired,
};

SingleQuestionType.defaultProps = {
  errorText: 'Please select an answer',
  errorField: false,
  onChange: () => { },
  selectedValue: {},
};

export default SingleQuestionType;
